import { defineComponent as _defineComponent } from 'vue'
import { __ } from '@@/bits/intl'
import { tailwindFlattenedColors } from '@@/bits/tailwind'
import { computed, nextTick, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OzLoadingSpinnerWithCheckmark',
  props: {
    size: { default: 48 },
    color: { default: 'white' },
    variation: { default: 'default' },
    darkMode: { type: [Boolean, String], default: 'auto' },
    isCheckmark: { type: Boolean, default: false },
    progress: { default: null },
    spinnerLabel: { default: __('Loading') },
    checkmarkLabel: { default: __('Done') }
  },
  emits: ['transformed-to-checkmark'],
  setup(__props: any, { emit }) {

const props = __props as { size: number, color: 'rainbow' | 'black' | 'white' | 'yellow' | 'purple', variation: 'default' | 'dashed', darkMode: boolean | 'auto', isCheckmark: boolean, progress: number | null, spinnerLabel: string, checkmarkLabel: string };





const loaderSize = computed(() => {
  return props.size
})

const loaderStyle = computed(() => {
  if (!props.size) return undefined
  return {
    width: `${loaderSize.value}px`,
    height: `${loaderSize.value}px`,
  }
})

const strokeWidth = computed(() => {
  if (!props.size) return 2
  if (props.size < 30) {
    return 4
  }
  return 2
})

const strokeColor = computed(() => {
  switch (props.color) {
    case 'black':
      return 'black'
    case 'white':
      return 'white'
    case 'purple':
      return tailwindFlattenedColors['grape-500']
    case 'yellow':
      return tailwindFlattenedColors['canary-500']
    default:
      return 'black'
  }
})

const isLastFrameAnimationFinished = ref(false)
const hasReachedFullProgress = ref(false)
watch(
  () => props.progress,
  (newValue) => {
    if (newValue === 1) {
      hasReachedFullProgress.value = true
    }
  },
)

// When transforming from spinner to checkmark, we need to wait for the last frame of the spinner animation to finish
// And then we can start the checkmark animation
function endAnimation(): void {
  isLastFrameAnimationFinished.value = true
  emit('transformed-to-checkmark')
}

const circlePath = ref<SVGPathElement | null>(null)
watch(
  () => props.isCheckmark,
  (newValue) => {
    if (!newValue) {
      return
    }
    isLastFrameAnimationFinished.value = false
    if (props.progress !== null || hasReachedFullProgress.value) {
      endAnimation()
      return
    }
    nextTick(() => {
      if (!circlePath.value) {
        endAnimation()
        return
      }
      const listener = () => {
        endAnimation()
        circlePath.value.removeEventListener('animationiteration', listener)
      }
      circlePath.value.addEventListener('animationiteration', listener)
    })
  },
  { immediate: true, flush: 'post' },
)

return { __sfc: true,props, emit, loaderSize, loaderStyle, strokeWidth, strokeColor, isLastFrameAnimationFinished, hasReachedFullProgress, endAnimation, circlePath }
}

})